module.exports = __webpack_public_path__ + "img/antisacm.9f385255.png";